import { ProductCollectionFilter } from 'src/types';
import { LayoutMode } from '../../../components/layout-buttons/types';

export const SET_PRODUCT_COLLECTION_LAYOUT = 'SET_PRODUCT_COLLECTION_LAYOUT';
export const UPDATE_PRODUCT_COLLECTION_FILTERS =
  'UPDATE_PRODUCT_COLLECTION_FILTERS';

export type SetProductCollectionLayoutAction = {
  type: typeof SET_PRODUCT_COLLECTION_LAYOUT;
  layout: LayoutMode;
};

export type UpdateProductCollectionFiltersAction = {
  type: typeof UPDATE_PRODUCT_COLLECTION_FILTERS;
  id: string;
  filters: ProductCollectionFilter[];
};

export const setProductCollectionLayout = (
  layout: LayoutMode
): SetProductCollectionLayoutAction => ({
  type: SET_PRODUCT_COLLECTION_LAYOUT,
  layout,
});

export const updateProductCollectionFilters = (
  id: string,
  filters: ProductCollectionFilter[]
): UpdateProductCollectionFiltersAction => ({
  type: UPDATE_PRODUCT_COLLECTION_FILTERS,
  id,
  filters,
});

export type ProductCollectionAction =
  | SetProductCollectionLayoutAction
  | UpdateProductCollectionFiltersAction;
